import jwt_decode from 'jwt-decode';

export const ID_TOKEN_KEY = `amex_id_token_${process.env.VUE_APP_DATALOG_ENV}`;
export const USER_ID = `amex_user_id_${process.env.VUE_APP_DATALOG_ENV}`;
export const ACCESS_TOKEN_KEY = `amex_access_token_${process.env.VUE_APP_DATALOG_ENV}`;

export interface TokenWithExpiry {
  exp?: number;
  sub: string;
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

export function logout() {
  clearIdToken();
  clearAccessToken();
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
  localStorage.removeItem(USER_ID);
}

export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}
export function getUserId() {
  return localStorage.getItem(USER_ID) || 'MobiAgentUserVisitSingapore';
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}

// function getTokenExpirationDate(encodedToken: string): Date | null {
//   const token = jwt_decode<TokenWithExpiry>(encodedToken);
//   if (!token.exp) {
//     return null;
//   }

//   const date = new Date(0);
//   date.setUTCSeconds(token.exp);

//   return date;
// }

// function isTokenExpired(token: string | null) {
//   if (token == null) {
//     return true;
//   }
//   const expirationDate = getTokenExpirationDate(token);
//   if (expirationDate == null) {
//     return true;
//   }
//   return expirationDate < new Date();
// }

export function isLoggedIn() {
  const idToken = getIdToken();
  return Boolean(idToken); // && !isTokenExpired(idToken);
}

// Helper function that will allow us to extract the access_token and id_token
export function getParameterByName(name: string): string {
  const match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
  return (match && decodeURIComponent(match[1].replace(/\+/g, ' '))) || '';
}

export function setAccessToken(token?: string) {
  const accessToken = token || getParameterByName('access_token');
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

export function setIdToken(id?: string) {
  const idToken = id || getParameterByName('id_token');
  localStorage.setItem(ID_TOKEN_KEY, idToken);
  const token = jwt_decode<TokenWithExpiry>(idToken);
  localStorage.setItem(USER_ID, token.sub);
}
